export default "__VITE_ASSET__BHda8HQ2__"